const trapFocus = function (elem) {
  const tabbable = elem.querySelectorAll(
    'select, input, textarea, button, a[href]'
  );

  const visibleTabbable = Array.from(tabbable).filter(el => {
    return (
      el.offsetWidth > 0 ||
      el.offsetHeight > 0 ||
      el.getClientRects().length > 0
    );
  });

  if (visibleTabbable.length === 0) return;

  const firstTabbable = visibleTabbable[0];
  const lastTabbable = visibleTabbable[visibleTabbable.length - 1];

  firstTabbable.focus();

  lastTabbable.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      firstTabbable.focus();
    }
  });

  firstTabbable.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      lastTabbable.focus();
    }
  });

  elem.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      elem.style.display = 'none';
    }
  });
};

export { trapFocus };
